import MainFrame from "../../../components/mainFrame";
import { Box, Button } from "@mui/material";
import styled from "@emotion/styled";
import StickyTable from "../../../components/table";
import Navbar from "../../../components/navbar";

import AddIcon from "@mui/icons-material/Add";

import { useModal } from "../../../components/modal";
import { DeleteModal } from "../../../components/appbar/modal";
import { smallButton } from "../../../components/Button";
import AddModal from "./modal";
import { useLocation, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import {
  useDeleteQuestionMutation,
  useGetQuizeQuestionsQuery,
} from "../../../app/services/questions.api";
import { Question } from "../../../types/quize";
import QuestionRow from "./QuestionRow";

interface Props {}
const Container = styled(Box)({
  padding: "1rem",
  width: "100%",
  height: "100%",
  minHeight: "90vh",
  maxHeight: "90vh",
});
function Questions(props: Props) {
  const { setShow, setContent } = useModal();
  const {
    state: { title: quizeName = "" },
  } = useLocation() as { state: { title: string } };
  const params = useParams() as { quiz: string };
  const { data, isLoading, isFetching } = useGetQuizeQuestionsQuery({
    quizeId: params.quiz,
  });
  const [deleteQuestion] = useDeleteQuestionMutation();

  function handleOpenModal(type: string, index?: number) {
    if (type === "edit") {
      setContent({
        title: " ویرایش سوال",
        body: <AddModal quizeId={params.quiz} />,
      });
    }
    if (type === "add") {
      setContent({
        title: " افزودن سوال",
        body: <AddModal quizeId={params.quiz} />,
      });
    }
    if (type === "delete" && typeof index !== "undefined") {
      setContent({
        title: "حذف سوال",
        body: (
          <DeleteModal
            handleDelete={() => {
              deleteQuestion({ quizeId: params.quiz, index })
                .unwrap()
                .then(() => {
                  setShow(false);
                })
                .catch((err) => {});
            }}
          />
        ),
      });
    }
    setShow(true);
  }

  return (
    <Container bgcolor="primary.light">
      <Helmet>
        <title> سوال ها | پنل ادمین azno.school</title>
      </Helmet>
      <Navbar title={`سوال های ${quizeName} `}>
        <Button
          onClick={() => handleOpenModal("add")}
          sx={[
            smallButton,
            {
              color: "divider",
              borderColor: "divider",
              borderStyle: "solid",
              borderWidth: "1px",
            },
          ]}
        >
          <AddIcon />
          افزودن سوال
        </Button>
      </Navbar>
      <StickyTable
        headers={[{ name: "عنوان" }, { name: "" }]}
        length={0}
        operations={true}
        isLoading={isLoading || isFetching}
      >
        {(data?.ids || []).map((id, index) => {
          const question = data?.entities[id] as Question;
          return (
            <QuestionRow
              key={question._id}
              {...question}
              index={index}
              onDelete={() => handleOpenModal("delete", index)}
            />
          );
        })}
      </StickyTable>
    </Container>
  );
}

export default MainFrame(Questions);
